import React from 'react';
import './Card.css';

const Card = ({ 
  children, 
  className = '',
  hoverable = false,
  bordered = true,
  ...props 
}) => {
  return (
    <div 
      className={`ui-card ${hoverable ? 'hoverable' : ''} ${bordered ? 'bordered' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`ui-card-header ${className}`} {...props}>
    {children}
  </div>
);

export const CardContent = ({ children, className = '', ...props }) => (
  <div className={`ui-card-content ${className}`} {...props}>
    {children}
  </div>
);

export const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`ui-card-footer ${className}`} {...props}>
    {children}
  </div>
);

export default Card;